import React from "react";
import { Button } from "react-materialize";

export default function VireProfileBtnMyProfile() {
  return (
    <Button
      className=""
      id="btn-my-profile"
      node="button"
      waves="light"
      onClick={() =>
        (window.location.href = `/employees/myprofile`)
      }
      style={{
        borderRadius: "8px",
        background: "#fff",
        color: "#26a69a",
        border: "2px solid #26a69a",
        boxShadow: "none",
        right: "125px",
        lineHeight: "20px"
      }}
    >
      View My Profile
    </Button>
  );
}
